import React from 'react'
import styled from 'styled-components'
import Slider from 'react-slick'
import SlideItem from './component'
import { Container } from 'reactstrap'
import { fontWeight } from 'themes/font'
import breakPoints from 'themes/breakPoints'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

const Section = styled.section`
  position: relative;
  text-align: center;
  .slick-prev:before,
  .slick-next:before {
    color: #0984e3;
    font-size: 28px;
  }
  @media (max-width: ${breakPoints.md.max}px) {
    padding-top: 32px;
    padding-bottom: 48px;
    .slick-prev {
      left: 0;
      z-index: 10;
    }
    .slick-next {
      right: 0;
      z-index: 10;
    }
  }
  @media (min-width: ${breakPoints.lg.min}px) {
    padding-bottom: 112px;
  }
`

const Heading = styled.div`
  margin: 0 auto;
  display: inline-flex;
  justify-content: center;
  margin-bottom: 56px;
  font-size: 2rem;
  font-weight: ${fontWeight.medium};
  background-image: linear-gradient(transparent 66%, rgba(0, 200, 255, 0.5) 34%);
  @media (max-width: ${breakPoints.md.max}px) {
    margin-bottom: 32px;
    font-size: 1.5rem;
  }
`

const Background = styled.img`
  position: absolute;
  left: 0;
  z-index: -1;
`

export default class SimpleSlider extends React.Component {
  render () {
    const settings = {
      speed: 500
    }
    const { aboutHeading, components } = this.props.data
    return (
      <Section>
        <Background src='/img/home-page/why-choose/bg1.svg' alt='Background' />
        <Container>
          <Heading className='wow fadeIn'>{aboutHeading}</Heading>
          <Slider {...settings} className='wow fadeIn'>
            {components.map((component, index) => (
              <SlideItem key={index} {...component} />
            ))}
          </Slider>
        </Container>
      </Section>
    )
  }
}
